export const FILE_TYPE_PDF = 'pdf';
export const FILE_TYPE_VIDEO = 'video';
export const POSTER_TYPE = 'image';

export function getMimeType(type) {
	switch (type) {
		case FILE_TYPE_PDF: return 'application/pdf';
		case FILE_TYPE_VIDEO: return 'video/*';
		case POSTER_TYPE: return 'image/jpeg,image/gif,image/png';
		default:
			return '*/*';
	}
}



// WEBPACK FOOTER //
// ./src/client/components/common/types.js